import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { AdminDevelopmentsService, AdminDevelopmentListItem } from '../services/adminDevelopments.service';
import styles from './AdminProjectDocumentsIndexPage.module.css';

export default function AdminProjectDocumentsIndexPage() {
  const [items, setItems] = useState<AdminDevelopmentListItem[]>([]);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    try {
      const res = await AdminDevelopmentsService.list({ page: 1, pageSize: 50 });
      const data = (res as any)?.data;
      const list = Array.isArray(data?.items) ? data.items : Array.isArray(data) ? data : [];
      setItems(list);
    } catch {
      setItems([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, []);

  const statusMeta = (status?: string) => {
    const key = (status || 'NONE').toUpperCase();
    if (key === 'UPLOADED') return { label: 'Cargado', className: styles.statusUploaded };
    if (key === 'IN_REVIEW') return { label: 'En revisión', className: styles.statusInReview };
    if (key === 'OBSERVED') return { label: 'Observado', className: styles.statusObserved };
    if (key === 'APPROVED') return { label: 'Aprobado', className: styles.statusApproved };
    return { label: 'Sin documentos', className: styles.statusNone };
  };

  if (loading) return <div className={styles.loading}>Cargando...</div>;

  return (
    <div className={styles.page}>
      <header className={styles.header}>
        <div>
          <p className={styles.eyebrow}>Administración</p>
          <h1 className={styles.title}>Revisión documental</h1>
          <p className={styles.subtitle}>Gestiona los documentos recibidos y asigna el estatus correcto.</p>
        </div>
        <button className={styles.refreshButton} type="button" onClick={load}>
          Actualizar
        </button>
      </header>

      <section className={styles.card}>
        {items.length === 0 ? (
          <div className={styles.emptyState}>
            <h2 className={styles.emptyTitle}>No hay proyectos</h2>
            <p className={styles.emptyText}>Cuando un proyecto cargue documentación, aparecerá aquí.</p>
          </div>
        ) : (
          <div className={styles.list}>
            {items.map((it) => {
              const statusInfo = statusMeta(it.documentation_status);
              return (
                <div key={it.id} className={styles.item}>
                  <div className={styles.itemInfo}>
                    <div className={styles.itemTitle}>{it.name}</div>
                    <div className={`${styles.statusBadge} ${statusInfo.className}`}>
                      {statusInfo.label}
                    </div>
                  </div>
                  <Link className={styles.reviewButton} to={`/admin/proyectos/${it.id}/documentos`}>
                    Revisar documentos
                  </Link>
                </div>
              );
            })}
          </div>
        )}
      </section>
    </div>
  );
}
